// The last loaded rows of an admin list, kept so a page paints at once on a
// revisit and refreshes quietly behind them (the way a mail app opens on
// what it last showed). In memory for the session and, trimmed to a size
// local storage will hold, on disk for the next sign-in on this device. Keyed
// per admin account, so one account never sees another's rows.

const memory = new Map();
const MAX_BYTES = 1_500_000; // local storage keeps lists below this; bigger ones live in memory only

const adminId = () => { try { return (JSON.parse(localStorage.getItem("adminInfo") || "{}") || {}).id || "anon"; } catch { return "anon"; } };
// `scope` names whose list it is: the admin account by default; an /app page
// passes its own (the signed-in user's id, or "device" for a guest)
const storageKey = (key, scope) => `adminList:${scope || adminId()}:${key}`;

export function readListCache(key, scope) {
  const k = storageKey(key, scope);
  if (memory.has(k)) return memory.get(k);
  try {
    const raw = localStorage.getItem(k);
    if (!raw) return null;
    const value = JSON.parse(raw);
    memory.set(k, value);
    return value;
  } catch { return null; }
}

export function writeListCache(key, value, scope) {
  const k = storageKey(key, scope);
  memory.set(k, value);
  try {
    const raw = JSON.stringify(value);
    if (raw.length <= MAX_BYTES) localStorage.setItem(k, raw);
    else localStorage.removeItem(k);
  } catch { /* storage full or blocked: memory still has it */ }
}

// One list inside a cached entry replaced (a swiped row gone, or back after
// Undo), so a reload paints the list as it stands; nothing to patch before
// the first load has been kept
export function patchListCache(key, field, rows, scope) {
  const cur = readListCache(key, scope);
  if (cur) writeListCache(key, { ...cur, [field]: rows }, scope);
}

// The /app side's scope: the signed-in user's id, else this device (a guest's
// lists are this device's lists)
export function userListScope() {
  try { return (JSON.parse(localStorage.getItem("userInfo") || "null") || {}).id || "device"; } catch { return "device"; }
}

export function clearListCaches() {
  memory.clear();
  try {
    Object.keys(localStorage).filter((k) => k.startsWith("adminList:")).forEach((k) => localStorage.removeItem(k));
  } catch { /* nothing to clear */ }
}
